<template>
  <div class="moblieContent">
    <header>
      <img
        class="logo"
        :src="require(`@/assets/img/moblie/caishijie/logo.png`)"
        :alt="'liuhe'"
      />
      <div class="headerInfo">
        <h3 class="lotteryTitle mr0">彩世界助手</h3>
        <p>一款为了协助彩世界苹果用户遇系统签名掉签，</p>
        <p>软件无法使用时的安装工具</p>
      </div>
      <div class="downloadContent">
        <a href="#" class="downloadBtn iosDownload" @click="intoSetting">
          立即信任
        </a>
      </div>
    </header>
    <section class="downloadHelper">
      <div class="flowContent">
        <div class="flowInfo mr0">
          <p>如遇操作問題，請按照下列操作流程安裝 &#8595;</p>
        </div>
        <div class="installFlow">
          <div class="title">
            <span>操作流程</span>
          </div>
          <ol class="flowList">
            <li>
              <p>
                点击下载时，请选择允许[此网站正在尝试下载一个配置描述文件。您要允许吗?]
              </p>
              <img src="@/assets/img/moblie/helper1.png" alt="help1" />
            </li>
            <li>
              <p>
                允许上述操作后，您将收到[已下载描述文件
                若要安装，请先在"设置"应用中查看描述文件。 ]
              </p>
              <img src="@/assets/img/moblie/helper2.png" alt="help2" />
              <span>前往桌面，按照以下步骤进行操作</span>
              <img src="@/assets/img/moblie/helper3.png" alt="help3" />
              <span>点击[设置]</span>
              <img src="@/assets/img/moblie/helper4.png" alt="help4" />
              <span>点击[通用]</span>
              <img src="@/assets/img/moblie/helper5.png" alt="help5" />
              <span>点击[描述文件与设备管理]</span>
              <img src="@/assets/img/moblie/helper6.png" alt="help6" />
              <span>点击[已下载的描述文件]</span>
              <img src="@/assets/img/moblie/helper7.png" alt="help7" />
              <span>最后一步 点击[安装]</span>
              <img src="@/assets/img/moblie/helper8.png" alt="help8" />
            </li>
            <li>
              <p>恭喜您成功下载彩世界助手！</p>
            </li>
          </ol>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {};
  },
  mounted() {
    this.scrollToTop();
    this.$nextTick(function () {
      //this.$emit()
      console.log("call api");
      this.loadDownload();
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    loadDownload() {
      setTimeout(function () {
        window.location.href = window.downloadHelper;
      }, 1500);
    },
    intoSetting(e) {
      if (e) {
        e.preventDefault();
      }
      window.location.href = window.iosVerification;
    },
  },
};
</script>
